import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/(root)/components/slider/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/assets/image/cloth.png");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/contact/index.tsx");
